import React from 'react';
import { styled } from '@mui/material/styles';
import { Button, Grid } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';

const StyledGrid = styled(Grid)(({ theme }) => ({
  borderRadius: '10px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  padding: '10px',
  borderRadius: '10px 10px 0px 0px',
  fontWeight: '400 !important',
  fontSize: '18px',
  lineHeight: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  color: theme.palette.primary.contrastText,
}));

const TopText = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  textAlign: 'center',
  fontSize: theme.typography.fontSize,
  fontWeight: 400,
}));

function EnterprisePlanBanner() {
  return (
    <StyledGrid container>
      <TitleGrid item xs={12}>
        <BusinessIcon style={{ marginRight: 8 }} />
        Enterprise
      </TitleGrid>
      <Grid item xs={12} padding="24px">
        <Grid container display="flex" alignItems="center" justifyContent="center" spacing={2}>
          <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
            <TopText>
              Need a custom plan with more actions, or additional requirements like SLAs,
              implementation, or private VPC deployments?
            </TopText>
          </Grid>
          <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
            <TopText>Contact us for a custom Enterprise plan and pricing</TopText>
          </Grid>
          <Grid item xs={12} display="flex" alignItems="center" justifyContent="center">
            <Button variant="outlined" id="chat_with_someone">
              Contact Us
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </StyledGrid>
  );
}

export default EnterprisePlanBanner;
